import { HttpError } from 'modules/http-client'
import { Action } from 'modules/store'

import { DepartmentLookup, Lookup } from '../components/lookup/models'

export const GET_LOOKUPS = '[lookups] GET ALL'
export const GET_LOOKUPS_SUCCESS = '[lookups] GET ALL SUCCESS'
export const GET_LOOKUPS_ERROR = '[lookups] GET ALL ERROR'

export class GetLookupsAction implements Action {
  readonly type = GET_LOOKUPS
  constructor(public payload: string) {}
}
export class GetLookupsSuccessAction implements Action {
  readonly type = GET_LOOKUPS_SUCCESS
  constructor(public payload: Lookup) {}
}
export class GetLookupsErrorAction implements Action {
  readonly type = GET_LOOKUPS_ERROR
  constructor(public payload: HttpError) {}
}

export const GET_DEPARTMENT_LOOKUPS = '[lookups] GET DEPARTMENT ALL'
export const GET_DEPARTMENT_LOOKUPS_SUCCESS = '[lookups] GET DEPARTMENT ALL SUCCESS'
export const GET_DEPARTMENT_LOOKUPS_ERROR = '[lookups] GET DEPARTMENT ALL ERROR'

export class GetDepartmentLookupsAction implements Action {
  readonly type = GET_DEPARTMENT_LOOKUPS
}
export class GetDepartmentLookupsSuccessAction implements Action {
  readonly type = GET_DEPARTMENT_LOOKUPS_SUCCESS
  constructor(public payload: DepartmentLookup[]) {}
}
export class GetDepartmentLookupsErrorAction implements Action {
  readonly type = GET_DEPARTMENT_LOOKUPS_ERROR
  constructor(public payload: HttpError) {}
}

export type LookupActions =
  | GetLookupsErrorAction
  | GetLookupsSuccessAction
  | GetLookupsAction
  | GetDepartmentLookupsAction
  | GetDepartmentLookupsErrorAction
  | GetDepartmentLookupsSuccessAction

export default LookupActions



// WEBPACK FOOTER //
// ./src/app/core/store/lookup.actions.ts